<template>

  <!-- 在模板中添加全局加载指示器 -->
  <div v-if="isGlobalLoading" class="global-loading-overlay">
    <div class="global-loading-content">
      <div class="loading-ring"></div>
      <p class="loading-text">{{ loadingText }}</p>
    </div>
  </div>

  <!-- 头部 -->
  <el-header class="app-header ali-header fixed-header" height="auto">

    <div class="header-glow header-glow--blue"></div>
    <div class="header-glow header-glow--orange"></div>

    <div class="header-container">

      <!-- 左：Logo -->
      <div class="logo-container" @click="navigateToHome">
        <img src="https://test.eprinttools.com/files/front-end/logo.svg" alt="易印工具 Logo" class="logo-img">
      </div>

      <!-- 中：导航菜单 (绝对定位居中) -->
      <el-menu
          v-if="!isUpdatePasswordPage"
          :default-active="activeMenu"
          mode="horizontal"
          class="ali-nav-menu"
          @select="handleMenuSelect"
      >
        <el-menu-item index="/home">首页</el-menu-item>

        <!-- 产品菜单 - 使用 el-dropdown -->
        <el-dropdown
            placement="bottom"
            trigger="hover"
            :class="{ 'is-active': isProductsMenuActive }"
            class="products-dropdown-wrapper"
            popper-class="products-dropdown-popper"
        >
          <div class="dropdown-trigger">
            <el-menu-item index="/products?id=6" class="dropdown-menu-item">产品</el-menu-item>
          </div>
          <template #dropdown>
            <!-- 下拉菜单内容 -->
            <div class="products-dropdown">
              <div class="dropdown-content">
                <!-- 第一列 -->
                <div class="dropdown-column">
                  <div class="dropdown-category">
                    <h3 class="category-name">图像校对</h3>
                    <div class="category-items">
                      <el-dropdown-item @click="navigateToProductList(1)" class="category-item">
                        <el-icon class="item-icon"><position /></el-icon>
                        <span class="item-name">易比图</span>
                        <el-icon class="item-arrow"><ArrowRight /></el-icon>
                      </el-dropdown-item>

                      <el-dropdown-item @click="navigateToProductList(6)" class="category-item">
                        <el-icon class="item-icon"><position /></el-icon>
                        <span class="item-name">易比图 V2</span>
                        <el-icon class="item-arrow"><ArrowRight /></el-icon>
                      </el-dropdown-item>
                    </div>
                  </div>

                  <div class="dropdown-category">
                    <h3 class="category-name">AI插件</h3>
                    <div class="category-items">
                      <el-dropdown-item @click="navigateToProductList(2)" class="category-item">
                        <el-icon class="item-icon"><position /></el-icon>
                        <span class="item-name">二维码</span>
                        <el-icon class="item-arrow"><ArrowRight /></el-icon>
                      </el-dropdown-item>
                      <el-dropdown-item @click="navigateToProductList(3)" class="category-item">
                        <el-icon class="item-icon"><position /></el-icon>
                        <span class="item-name">智能刀模</span>
                        <el-icon class="item-arrow"><ArrowRight /></el-icon>
                      </el-dropdown-item>
                      <el-dropdown-item @click="navigateToProductList(4)" class="category-item">
                        <el-icon class="item-icon"><position /></el-icon>
                        <span class="item-name">标签管理</span>
                        <el-icon class="item-arrow"><ArrowRight /></el-icon>
                      </el-dropdown-item>
                      <el-dropdown-item @click="navigateToProductList(5)" class="category-item">
                        <el-icon class="item-icon"><position /></el-icon>
                        <span class="item-name">美版能效标签</span>
                        <el-icon class="item-arrow"><ArrowRight /></el-icon>
                      </el-dropdown-item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-dropdown>

        <el-menu-item index="/solutions" >解决方案</el-menu-item>

        <el-menu-item index="/corp" >关于我们</el-menu-item>

      </el-menu>

      <!-- 右侧功能区 -->
      <div v-if="!isUpdatePasswordPage" class="header-right-area">
        <!-- 用户相关 -->
        <div class="user-actions">
          <span v-if="!currentUser" class="login-action" @click="navigateToLogin">
          登录/注册
          </span>

          <el-dropdown v-else @command="handleUserCommand" class="user-dropdown" popper-class="user-dropdown-popper">
            <div class="user-info-wrapper">
              <el-avatar :size="28" :src="currentUser.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" />
              <span class="user-name">{{ currentUser.nickname }}</span>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="profile">
                  <el-icon><User /></el-icon>
                  个人中心
                </el-dropdown-item>

                <el-dropdown-item divided command="logout">
                  <el-icon><SwitchButton /></el-icon>
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
  </el-header>

  <div class="layout-wrapper">
    <el-container class="layout-container">

      <!-- 移动端Logo（只在移动端显示） -->
      <div class="mobile-logo">
        <img src="https://test.eprinttools.com/files/front-end/logo.svg" alt="易印 Logo" class="logo-img">
      </div>

      <!-- 主内容区域 -->
      <el-main class="app-main">
        <router-view />
      </el-main>

      <!-- 回到顶部按钮 -->
      <transition name="back-top-fade">
        <button
            v-show="showBackTop"
            class="back-top-btn"
            @click="scrollToTop"
            aria-label="返回顶部"
            title="回到顶部"
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 15l-6-6-6 6"/>
          </svg>
        </button>
      </transition>

      <!-- 底部区域 -->
      <el-footer v-if="!isLrPage" class="app-footer" :class="{ 'reduced-footer': !isHomePage }" height="auto">
        <div class="footer-content" :class="{ 'reduced-layout': !isHomePage }">
          <!-- 首页完整页脚 -->
          <div v-if="isHomePage || isCorpPage" class="footer-main">
            <div class="footer-glow footer-glow--blue"></div>
            <div class="footer-glow footer-glow--orange"></div>
            <div class="footer-sections">
              <!-- 网站介绍 -->
              <div class="footer-section">
                <div class="footer-logo">
                  <span class="logo-text">易印工具</span>
                </div>
                <p class="footer-desc">
                  专业的印前设计工具，让设计更加高效精准。我们致力于为各行业提供最优质的印前解决方案。
                </p>
              </div>

              <!-- 产品与服务 -->
              <div v-show="!isMobile" class="footer-section">
                <h4 class="section-title">产品与服务</h4>
                <ul class="footer-links">
                  <li><router-link :to="{ path: '/products', query: { id: 6 } }">易比图 V2</router-link></li>
                  <li><router-link :to="{ path: '/products', query: { id: 2 } }">二维码插件</router-link></li>
                  <li><router-link :to="{ path: '/products', query: { id: 3 } }">智能刀模</router-link></li>
                  <li><router-link :to="{ path: '/products', query: { id: 4 } }">能效标签</router-link></li>
                  <li><router-link :to="{ path: '/products', query: { id: 5 } }">美版能效</router-link></li>
                </ul>
              </div>

              <!-- 帮助与支持 -->
              <div v-show="!isMobile" class="footer-section">
                <h4 class="section-title">快速链接</h4>
                <ul class="footer-links">
                  <li><router-link to="/">首页</router-link></li>
                  <li><router-link to="/solutions">解决方案</router-link></li>
                  <li><router-link to="/corp">关于我们</router-link></li>
                  <li><router-link to="/login">登录注册</router-link></li>
                </ul>
              </div>

              <!-- 联系方式 -->
              <div class="footer-section">
                <h4 class="section-title">联系我们</h4>
                <div class="contact-info">
                  <div class="contact-item">
                    <el-icon><Message /></el-icon>
                    <span>3052594895@qq.com</span>
                  </div>
                  <div class="contact-item">
                    <el-icon><Phone /></el-icon>
                    <span>18925330037</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 底部版权信息 -->
            <div class="footer-bottom">
              <div class="copyright-section">
                <div class="copyright-text">
                  © 2025 中山市易印网络科技有限公司.保留所有权利.
                </div>

              </div>
              <div class="certification-info">
                <div class="beian-container">
                  <img src="https://test.eprinttools.com/files/front-end/police.png" alt="公安备案图标" class="beian-icon">
                  <a href="http://www.beian.gov.cn" target="_blank" class="beian-link">
                    粤公网安备 44200002443702号
                  </a>
                  <span class="divider">|</span>
                  <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
                    粤ICP备16014837号
                  </a>
                </div>
                <div class="legal-links">
                  <a href="/privacyPolicy" @click.prevent="navigateToPrivacyPolicy" class="legal-link">隐私政策</a>
                  <span class="divider">|</span>
                  <a href="/userAgreement" @click.prevent="navigateToUserAgreement" class="legal-link">用户协议</a>
                </div>
              </div>
            </div>
          </div>

          <!-- 非首页简化页脚 -->
          <div v-else class="footer-simple">
            <div class="footer-bottom simple">
              <!-- 第一行：版权信息 -->
              <div class="copyright-section">
                <div class="copyright-text">
                  © 2025 中山市易印网络科技有限公司.保留所有权利.
                </div>
              </div>

              <!-- 第二行：备案信息 -->
              <div class="certification-info">
                <div class="beian-container">
                  <img src="https://test.eprinttools.com/files/front-end/police.png" alt="公安备案图标" class="beian-icon">
                  <a href="http://www.beian.gov.cn" target="_blank" class="beian-link">
                    粤公网安备 44200002443702号
                  </a>
                  <span class="divider">|</span>
                  <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
                    粤ICP备16014837号
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-footer>

      <!-- 移动端底部导航栏 -->
      <div class="mobile-bottom-nav" v-show="isMobile">
        <!-- 移动端导航项保持不变 -->
        <div :width="160">
          <div class="mobile-nav-item" @click="navigateToHome()">
            <div class="nav-text">首页</div>
          </div>
        </div>

        <el-dropdown
            placement="top"
            trigger="click"
            :width="160"
            :visible="popoverVisibleB"
            @visible-change="popoverVisibleB = $event">
          <div class="mobile-nav-item">
            <div class="nav-text">搜索</div>
          </div>
          <template #dropdown>
            <el-dropdown-menu class="mobile-dropdown-menu">
              <el-dropdown-item>搜索人才</el-dropdown-item>
              <el-dropdown-item>搜索任务</el-dropdown-item>
              <el-dropdown-item>发布任务</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>

        <el-dropdown
            placement="top"
            trigger="click"
            :width="160"
            router
            :visible="popoverVisibleC"
            @visible-change="popoverVisibleC = $event">
          <div class="mobile-nav-item">
            <div class="nav-text">菜单</div>
          </div>
          <template #dropdown>
            <el-dropdown-menu class="mobile-dropdown-menu">
              <el-dropdown-item @click="handleMenuSelect('/pluginlist')">插件列表</el-dropdown-item>
              <el-dropdown-item>人才雇佣</el-dropdown-item>
              <el-dropdown-item>任务大厅</el-dropdown-item>
              <el-dropdown-item>印前素材</el-dropdown-item>
              <el-dropdown-item>印前课堂</el-dropdown-item>
              <el-dropdown-item>印前社区</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>

        <div :width="160">
          <div class="mobile-nav-item">
            <div class="nav-text">我的</div>
          </div>
        </div>
      </div>
    </el-container>

  </div>

</template>


<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, markRaw, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  Search, User, Monitor, SwitchButton, ArrowRight, Position,
  ChatDotRound, Phone, Document, VideoCamera, ArrowUp  }
  from '@element-plus/icons-vue';
import request from '@/utils/request';
import { ElMessage } from 'element-plus';
import { eventBus } from '@/utils/eventBus'

const router = useRouter();
const route = useRoute();

// 响应式数据
const searchQuery = ref('');
const activeMenu = ref('/');
const isMobile = ref(false);
const popoverVisibleB = ref(false);
const popoverVisibleC = ref(false);

const showBackTop = ref(false);

// 全局用户状态
const currentUser = eventBus.getGlobalUser()

// 添加全局加载状态
const isGlobalLoading = ref(false)
const loadingText = ref('')

// 技术支持项
// const supportItems = ref([
//   {
//     icon: markRaw(ChatDotRound),
//     title: '在线客服',
//     route: '/user-chat' // 添加路由信息
//   }
//   // { icon: markRaw(Phone), title: '电话支持' },
//   // { icon: markRaw(Document), title: '文档中心' },
//   // { icon: markRaw(VideoCamera), title: '视频教程' }
// ])

// 技术支持菜单点击处理
// const handleSupportClick = (item) => {
//   if (item.title === '在线客服') {
//     navigateToIM();
//   }
//   // 可以在这里添加其他菜单项的处理逻辑
// };

const enterpriseFormRef = ref(null);

// 计算属性
const isLrPage = computed(() => {
  return route.path === '/login' || route.path === '/register' || route.path === '/bind-phone' || route.path === '/updatePassword';
});

const isUpdatePasswordPage = computed(() => {
  return route.path === '/updatePassword';
});

const isHomePage = computed(() => {
  return route.path === '/' || route.path === '/home';
});

const isCorpPage = computed(() => {
  return route.path === '/corp';
});

const isConsoleRoute = computed(() => {
  return route.path.startsWith('/console');
});

const isProductsMenuActive = computed(() => {
  return route.path.includes('/products') || route.path.includes('/pluginlist');
});

// 是否显示技术支持菜单
const showSupportMenu = computed(() => {
  return route.path !== '/user-chat' && route.path !== '/customer-service';
});

// 监听路由变化
watch(() => route.path, (newPath) => {
  activeMenu.value = newPath;

  // 登录页面时隐藏滚动条
  if (newPath === '/login' || newPath === '/register' || newPath === '/updatePassword') {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
}, { immediate: true });

// 方法
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};


const handleUserCommand = (command) => {
  switch (command) {
    case 'profile':
      router.push('/profile');
      break;
    case 'logout':
      handleLogout();
      break;
  }
};

const navigateToLogin = () => {
  router.push('/login');
};

const navigateToHome = () => {
  router.push('/');
};

const navigateToIM = () => {
  console.log('🔄 点击在线客服，检查用户身份...');

  // 先检查是否有token（是否登录）
  const token = localStorage.getItem('auth_token');

  console.log('Token状态:', token);

  if (!token) {
    console.log('用户未登录，直接跳转到用户聊天页面');
    router.push('/user-chat');
    return;
  }

  console.log('用户已登录，检查客服身份...');

  // 有token，检查是否为客服
  request.get('/im/customer-service/check')
      .then(response => {
        console.log('客服身份检查响应:', response);

        if (response.code === '200' && response.data.isCustomerService) {
          console.log('✅ 用户是客服，跳转到客服工作台');
          router.push('/customer-service');
        } else {
          console.log('❌ 用户不是客服，跳转到用户聊天页面');
          router.push('/user-chat');
        }
      })
      .catch(error => {
        console.error('检查客服身份失败:', error);
        // 检查失败时默认跳转到用户聊天页面
        router.push('/user-chat');
      });
}

const navigateToConsole = () => {
  router.push('/console');
};

const navigateToPrivacyPolicy = () => {
  router.push('/privacyPolicy');
}

const navigateToUserAgreement = () => {
  router.push('/userAgreement');
}

const navigateToProducts = (productName) => {
  router.push({
    path: '/products',
    query: { name: productName }
  });
};

const navigateToProductList = (id) => {
  router.push(`/products?id=${id}`);
};

const handleMenuSelect = (index) => {
  router.push(index);
};

const performSearch = (type = '') => {
  if (searchQuery.value.trim()) {
    const path = type === 'artist' ? '/search/artist' :
        type === 'mission' ? '/search/mission' : '/search';

    router.push({
      path,
      query: { q: searchQuery.value.trim() }
    });
    searchQuery.value = '';
  }
};

// 获取用户信息
const getCurrentUserInfo = async () => {
  const token = localStorage.getItem('auth_token');

  if (!token) {
    eventBus.clearUser();
    return;
  }

  try {
    isGlobalLoading.value = true
    loadingText.value = '正在加载用户信息...'

    const res = await request.get('/user/current');
    eventBus.setUser(res.data);

    // 添加短暂延迟确保状态完全更新
    await new Promise(resolve => setTimeout(resolve, 200));

  } catch (error) {
    console.error('获取当前用户信息失败:', error);
    // 如果获取用户信息失败，清除无效token
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
    }
    eventBus.clearUser();
  } finally {
    isGlobalLoading.value = false
    loadingText.value = ''
  }
};

// 处理登录成功的方法
const handleLoginSuccess = async () => {
  isGlobalLoading.value = true
  loadingText.value = '登录成功，正在加载...'

  try {
    // 确保token已经存储
    await new Promise(resolve => setTimeout(resolve, 300));

    // 获取用户信息
    await getCurrentUserInfo();

    // 再次短暂延迟确保状态更新完成
    await new Promise(resolve => setTimeout(resolve, 200));

  } finally {
    isGlobalLoading.value = false
    loadingText.value = ''
  }
}

// 监听登录事件
eventBus.onLogin(handleLoginSuccess)

// 退出登录
const handleLogout = async () => {
  try {
    const token = localStorage.getItem('auth_token');

    if (token) {
      await request.post('/auth/logout');
    }

    localStorage.removeItem('auth_token');
    eventBus.clearUser(); // 使用 eventBus 清除用户

    router.push('/home');
  } catch (error) {
    console.error('退出登录失败:', error);
    localStorage.removeItem('auth_token');
    eventBus.clearUser(); // 使用 eventBus 清除用户
    router.push('/home');
  }
};

// 处理函数
const handleLoginRefresh = () => {
  // 重新获取用户信息
  getCurrentUserInfo()
}

// 处理用户信息更新的方法
const handleUserProfileUpdated = (updateData) => {
  if (!currentUser.value) return

  // console.log('收到用户信息更新:', updateData)

  if (updateData.type === 'avatar') {
    // 更新头像
    currentUser.value.avatar = updateData.data
    // 同时更新 eventBus 中的全局用户信息
    eventBus.setUser({ ...currentUser.value, avatar: updateData.data })
  } else if (updateData.type === 'nickname') {
    // 更新昵称
    currentUser.value.nickname = updateData.data
    // 同时更新 eventBus 中的全局用户信息
    eventBus.setUser({ ...currentUser.value, nickname: updateData.data })
  }

  ElMessage.success('用户信息已更新')
}

const handleScroll = () => {
  // 滚动超过 300px 时显示按钮
  showBackTop.value = window.scrollY > 300;
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// 生命周期钩子
onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
  getCurrentUserInfo();
  // 监听登录事件
  eventBus.onLogin(handleLoginRefresh)

  // 监听用户信息更新事件
  eventBus.on('user-profile-updated', handleUserProfileUpdated)

  window.addEventListener('scroll', handleScroll);
  // 初始化时检查一次滚动位置
  handleScroll();
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
  // 移除监听
  eventBus.offLogin(handleLoginRefresh)

  eventBus.off('user-profile-updated', handleUserProfileUpdated)
  window.removeEventListener('scroll', handleScroll);
});

</script>

<style>
/* 全局样式 - 消除默认边距 */
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>

<style scoped>
/* ========== 全局加载指示器 ========== */
.global-loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  animation: fadeIn 0.4s ease-out;
}

.global-loading-content {
  text-align: center;
  background: transparent;
  padding: 0;
  box-shadow: none;
  border-radius: 0;
  animation: none;
}

.loading-ring {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 4px solid rgba(59, 130, 246, 0.15);
  border-top-color: #3b82f6;
  border-right-color: #f97316;
  animation: spin 0.9s linear infinite;
  margin: 0 auto;
}

.loading-text {
  display: none;
}

@keyframes fadeIn {
  from { opacity: 0; backdrop-filter: blur(0px); }
  to { opacity: 1; backdrop-filter: blur(14px); }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* ========== 固定头部 ========== */
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(18px) saturate(180%);
  -webkit-backdrop-filter: blur(18px) saturate(180%);
  border-bottom: 1px solid rgba(226, 232, 240, 0.6);
}

.fixed-header::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.4), rgba(249, 115, 22, 0.4), transparent);
}

/* 头部装饰光晕 */
.header-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  pointer-events: none;
  z-index: 0;
}
.header-glow--blue {
  width: 280px;
  height: 280px;
  top: -140px;
  left: 8%;
  background: rgba(59, 130, 246, 0.18);
}
.header-glow--orange {
  width: 240px;
  height: 240px;
  top: -130px;
  right: 6%;
  background: rgba(249, 115, 22, 0.14);
}

.ali-header {
  background: transparent;
  color: #0f172a;
  border-bottom: none;
  padding: 0;
}

.header-container {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 32px;
  height: 64px;
  max-width: 1200px;
}

/* Logo 靠左 */
.logo-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.3s ease;
  z-index: 2;
}

.logo-container:hover {
  opacity: 0.8;
}

.logo-img {
  height: 64px;                /* 布局盒尺寸保持不变 */
  width: auto;
  -ms-interpolation-mode: bicubic;
  transform: scale(2);      /* 视觉放大 1.35 倍 */
  transform-origin: center; /* 从左侧居中缩放，避免向右挤压 */
  pointer-events: none;        /* 放大后的溢出区域不拦截点击 */
}

.logo-text {
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  margin-left: 10px;
}

/* ========== 导航菜单 (居中: flex:1 + justify-content:center) ========== */
.ali-nav-menu {
  background: transparent;
  border: none;
  height: 64px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

:deep(.ali-nav-menu .el-menu-item) {
  height: 38px;
  line-height: 38px;
  color: rgba(15, 23, 42, 0.7);
  font-size: 14px;
  font-weight: 500;
  border-bottom: none !important;
  border-radius: 10px;
  padding: 0 16px;
  margin: 0 2px;
  white-space: nowrap;
  position: relative;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

:deep(.ali-nav-menu .el-menu-item:hover) {
  background: rgba(59, 130, 246, 0.06) !important;
  color: #0f172a !important;
  border-bottom: none;
}

:deep(.ali-nav-menu .el-menu-item.is-active) {
  background: rgba(59, 130, 246, 0.1) !important;
  color: #2563eb !important;
  border-bottom: none;
}

/* 底部渐变指示条, 背景高亮 */
:deep(.ali-nav-menu .el-menu-item)::after {
  content: '';
  position: absolute;
  bottom: -2px;                /* 调整与文字的距离 */
  left: 50%;
  width: 0;
  height: 2.5px;
  background: linear-gradient(90deg, #3b82f6, #f97316);
  border-radius: 2px;
  transform: translateX(-50%);
  transition: width 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

:deep(.ali-nav-menu .el-menu-item:hover)::after {
  width: 70%; /* 可根据喜好调整，也可用 100% */
}

:deep(.ali-nav-menu) .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
:deep(.ali-nav-menu) .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: rgba(59, 130, 246, 0.06) !important;
}

/* ========== 产品下拉菜单 ========== */
.products-dropdown-wrapper {
  height: 64px;
  display: flex;
  align-items: center;
}

.dropdown-trigger {
  height: 100%;
  outline: none !important;
  display: flex;
  align-items: center;
}

:deep(.products-dropdown-wrapper .dropdown-menu-item) {
  height: 38px;
  line-height: 38px;
  color: rgba(15, 23, 42, 0.7);
  font-size: 14px;
  font-weight: 500;
  border-bottom: none !important;
  border-radius: 10px;
  padding: 0 16px;
  margin: 0 2px;
  white-space: nowrap;
  position: relative;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 隐藏 el-dropdown 默认箭头（重要：去除下拉框箭头） */
:deep(.products-dropdown-wrapper .el-dropdown__caret-icon),
:deep(.products-dropdown-wrapper .el-dropdown .el-icon--right),
:deep(.products-dropdown-wrapper .dropdown-menu-item .el-icon.arrow-down) {
  display: none !important;
}

:deep(.products-dropdown-wrapper .dropdown-menu-item:hover) {
  background: rgba(59, 130, 246, 0.06) !important;
  color: #0f172a !important;
}

:deep(.products-dropdown-wrapper.is-active .dropdown-menu-item) {
  background: rgba(59, 130, 246, 0.1) !important;
  color: #2563eb !important;
}

/* 底部指示条 */
:deep(.products-dropdown-wrapper .dropdown-menu-item)::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2.5px;
  background: linear-gradient(90deg, #3b82f6, #f97316);
  border-radius: 2px;
  transform: translateX(-50%);
  transition: width 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

:deep(.products-dropdown-wrapper .dropdown-menu-item:hover)::after {
  width: 70%;
}

:deep(.products-dropdown-wrapper .el-dropdown-menu) {
  padding: 0;
  border: none;
}

:deep(.products-dropdown-wrapper .el-dropdown-menu__item) {
  padding: 0;
}

:deep(.products-dropdown-wrapper .category-item) {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.25s ease;
  color: #475569;
  position: relative;
  width: 100%;
}

:deep(.products-dropdown-wrapper .category-item:hover) {
  background: rgba(59, 130, 246, 0.06);
  color: #2563eb;
}

/* 下拉面板内容样式 */
.products-dropdown {
  width: 340px;
  padding: 0;
  overflow: hidden;
}

.dropdown-content {
  display: flex;
  padding: 24px;
  gap: 24px;
  background:
      radial-gradient(ellipse 300px 200px at 0% 0%, rgba(59, 130, 246, 0.06), transparent 60%),
      radial-gradient(ellipse 280px 180px at 100% 100%, rgba(249, 115, 22, 0.05), transparent 60%),
      #ffffff;
}

.dropdown-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.dropdown-category {
  margin-bottom: 0;
}

.category-name {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  line-height: 1.2;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  position: relative;
}

.category-name::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 32px;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #f97316);
  border-radius: 1px;
}

.category-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.category-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.25s ease;
  color: #475569;
  position: relative;
}

.category-item:hover {
  background: rgba(59, 130, 246, 0.06);
  color: #2563eb;
}

.item-icon {
  color: #3b82f6;
  margin-right: 10px;
  font-size: 14px;
  transition: all 0.25s ease;
}

.category-item:hover .item-icon {
  color: #f97316;
  transform: scale(1.15);
}

.item-name {
  font-size: 14px;
  font-weight: 500;
  color: inherit;
  line-height: 1.3;
  transition: all 0.25s ease;
  flex: 1;
}

.item-arrow {
  color: #cbd5e1;
  font-size: 12px;
  opacity: 0;
  transform: translateX(-4px);
  transition: all 0.25s ease;
}

.category-item:hover .item-name {
  color: #2563eb;
}

.category-item:hover .item-arrow {
  opacity: 1;
  transform: translateX(0);
  color: #f97316;
}

/* ========== 右侧区域 ========== */
.header-right-area {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.user-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.login-action {
  color: #475569;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 18px;
  border-radius: 10px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.3);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.login-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(59, 130, 246, 0.4);
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
}

.user-dropdown {
  cursor: pointer;
  margin-left: 4px;
}

.user-info-wrapper {
  display: flex;
  align-items: center;
  padding: 5px 12px 5px 5px;
  border-radius: 10px;
  outline: none !important;
  background: transparent;
}

.user-info-wrapper:hover {
  background:  rgba(226, 232, 240, 0.8);
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.12);
}

.user-name {
  margin: 0 8px 0 8px;
  font-size: 14px;
  color: #1e293b;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

:deep(.user-dropdown .el-dropdown-menu__item) {
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 0;
  border-radius: 10px;
  margin: 0;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  min-width: 180px;
  color: #334155;
  font-weight: 500;
}

:deep(.user-dropdown .el-dropdown-menu__item:hover) {
  background: transparent;
  color: #2563eb;
}

:deep(.user-dropdown .el-dropdown-menu__item .el-icon) {
  margin-right: 0;
  font-size: 16px;
}

.user-caret {
  font-size: 12px;
  color: #94a3b8;
  margin-left: 4px;
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), color 0.3s ease;
}

.user-info-wrapper:hover .user-caret {
  color: #2563eb;
  transform: rotate(90deg);
}

/* ========== 布局容器 ========== */
.layout-wrapper {
  min-height: calc(100vh - 64px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background:
      radial-gradient(ellipse 900px 600px at 10% 0%, rgba(59, 130, 246, 0.05), transparent 60%),
      radial-gradient(ellipse 800px 500px at 90% 5%, rgba(249, 115, 22, 0.04), transparent 55%),
      #f8fafc;
  margin-top: 64px;
}

.layout-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.app-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background: transparent;
  overflow: visible;
  min-height: 0;
}

/* ========== 回到顶部按钮 (浮动) ========== */
.back-top-btn {
  position: fixed;
  bottom: 36px;
  right: 36px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow:
      0 4px 16px rgba(91, 141, 239, 0.15),
      0 1px 4px rgba(15, 23, 42, 0.06),
      0 1px 0 rgba(255, 255, 255, 0.9) inset;
  color: #5b8def;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 999;
  padding: 0;
}

.back-top-btn:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.85);
  box-shadow:
      0 8px 28px rgba(91, 141, 239, 0.25),
      0 2px 8px rgba(15, 23, 42, 0.08),
      0 1px 0 rgba(255, 255, 255, 0.9) inset;
  color: #4a7ddb;
}

.back-top-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(91, 141, 239, 0.15);
}

/* 淡入淡出过渡（沿用你原有的 back-top-fade） */
.back-top-fade-enter-active,
.back-top-fade-leave-active {
  transition: all 0.3s ease;
}
.back-top-fade-enter-from,
.back-top-fade-leave-to {
  opacity: 0;
  transform: translateY(12px);
}

/* ========== 底部 (浅色主题, 参考主流官网) ========== */
.app-footer {
  background:
      radial-gradient(ellipse 600px 300px at 15% 0%, rgba(59, 130, 246, 0.06), transparent 60%),
      radial-gradient(ellipse 500px 280px at 85% 10%, rgba(249, 115, 22, 0.05), transparent 60%),
      #fafbfc;
  color: #475569;
  padding: 0;
  border-top: 1px solid rgba(226, 232, 240, 0.8);
  flex-shrink: 0;
  margin-top: auto;
  position: relative;
  overflow: hidden;
}

.app-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent 10%, rgba(59, 130, 246, 0.5) 35%, rgba(249, 115, 22, 0.5) 65%, transparent 90%);
}

.footer-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

/* 首页完整页脚 */
.footer-main {
  padding: 56px 24px 24px;
  position: relative;
}

.footer-glow {
  display: none;
}

.footer-sections {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1.2fr;
  gap: 40px;
  margin-bottom: 32px;
  padding-bottom: 28px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  position: relative;
  z-index: 1;
}

.footer-section:first-child {
  padding-right: 20px;
}

.footer-logo {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.footer-logo .logo-img {
  height: 40px;
  width: auto;
  margin-right: 12px;
}

.logo-text {
  font-size: 1.4rem;
  font-weight: 800;
  background: linear-gradient(135deg, #3b82f6, #f97316);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.footer-desc {
  color: #64748b;
  line-height: 1.75;
  font-size: 0.9rem;
  margin: 0;
  max-width: 320px;
}

.section-title {
  color: #1e293b;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 20px;
  position: relative;
  letter-spacing: 0.3px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 28px;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #f97316);
  border-radius: 1px;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: #64748b;
  text-decoration: none;
  font-size: 0.88rem;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  display: inline-block;
  cursor: pointer;
}

.footer-links a:hover {
  color: #2563eb;
  transform: translateX(4px);
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #64748b;
  font-size: 0.88rem;
  transition: color 0.3s ease;
}

.contact-item:hover {
  color: #1e293b;
}

.contact-item .el-icon {
  color: #ff7e5f;
  font-size: 1rem;
}

/* 底部版权区域 */
.footer-bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.copyright-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 200px;
}

.copyright-text {
  color: #94a3b8;
  font-size: 0.86rem;
}

.legal-links {
  display: flex;
  align-items: center;
  gap: 10px;
}

.legal-link {
  color: #94a3b8;
  text-decoration: none;
  font-size: 0.84rem;
  transition: color 0.3s ease;
  cursor: pointer;
}

.legal-link:hover {
  color: #2563eb;
}

.divider {
  color: #cbd5e1;
  font-size: 0.8rem;
}

.certification-info {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.beian-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.beian-icon {
  height: 16px;
  width: auto;
}

.beian-link, .icp-link {
  color: #94a3b8;
  text-decoration: none;
  font-size: 0.8rem;
  transition: color 0.3s ease;
}

.beian-link:hover, .icp-link:hover {
  color: #2563eb;
}

/* 非首页简化页脚 */
.footer-simple {
  padding: 24px;
}

.footer-bottom.simple {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  gap: 20px;
}

.footer-bottom.simple .copyright-section {
  flex-direction: row;
  align-items: center;
  gap: 20px;
}

.footer-bottom.simple .certification-info {
  justify-content: flex-end;
}

/* ========== 响应式 ========== */
@media (max-width: 1200px) {
  .header-container {
    padding: 0 16px;
  }

  .footer-sections {
    grid-template-columns: 2fr 1fr 1fr 1.2fr;
    gap: 28px;
  }
}

@media (max-width: 992px) {
  .header-container {
    width: 100%;
    padding: 0 15px;
  }
}

@media (max-width: 768px) {
  .layout-wrapper {
    margin-top: 0;
    padding-bottom: 64px;
  }

  .fixed-header {
    display: none !important;
  }

  .mobile-logo {
    display: flex !important;
    justify-content: center;
    padding: 14px 0;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(226, 232, 240, 0.6);
  }

  .app-main {
    flex: 1;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background: transparent;
    overflow: visible;
  }

  .back-top-btn {
    bottom: 24px;
    right: 24px;
    width: 40px;
    height: 40px;
  }

  .app-footer {
    padding-bottom: 64px;
  }

  .footer-main {
    padding: 40px 18px 18px;
  }

  .footer-sections {
    grid-template-columns: 1fr;
    gap: 28px;
    margin-bottom: 24px;
    padding-bottom: 24px;
  }

  .footer-section:first-child {
    padding-right: 0;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .copyright-section {
    flex-direction: column;
    gap: 10px;
  }

  .certification-info {
    flex-direction: column;
    gap: 10px;
  }

  .legal-links {
    justify-content: center;
  }

  .mobile-bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: 0 -4px 24px rgba(15, 23, 42, 0.08);
    border-top: 1px solid rgba(226, 232, 240, 0.6);
    z-index: 1000;
  }

  .mobile-nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;
    cursor: pointer;
    transition: all 0.3s;
    -webkit-tap-highlight-color: transparent;
    tap-highlight-color: transparent;
  }

  .mobile-nav-item:hover {
    background: rgba(59, 130, 246, 0.06);
  }

  .nav-text {
    font-size: 14px;
    color: #475569;
    font-weight: 500;
  }

  .mobile-dropdown-menu {
    border-radius: 16px;
    padding: 8px;
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.15);
    border: 1px solid rgba(226, 232, 240, 0.6);
  }

  .mobile-dropdown-menu .el-dropdown-menu__item {
    font-size: 14px;
    padding: 10px 16px;
    color: #334155;
    border-radius: 10px;
    transition: all 0.2s;
    margin: 2px 0;
  }

  .mobile-dropdown-menu .el-dropdown-menu__item:not(:last-child) {
    border-bottom: none;
  }

  .mobile-dropdown-menu .el-dropdown-menu__item:hover {
    background-color: rgba(59, 130, 246, 0.08);
    color: #2563eb;
  }

  .mobile-logo .logo-img {
    width: 120px;
    height: auto;
  }

  .footer-simple {
    padding: 18px 12px;
  }

  .footer-bottom.simple {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 12px;
  }

  .footer-bottom.simple .copyright-section {
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
  }

  .footer-bottom.simple .certification-info {
    justify-content: center;
    width: 100%;
  }

  .footer-bottom.simple .copyright-text {
    font-size: 0.8rem;
    color: #94a3b8;
    line-height: 1.4;
  }

  .footer-bottom.simple .beian-container {
    justify-content: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .footer-bottom.simple .beian-link,
  .footer-bottom.simple .icp-link {
    font-size: 0.75rem;
    color: #94a3b8;
  }

  .footer-bottom.simple .divider {
    font-size: 0.7rem;
    color: #cbd5e1;
  }

  .footer-bottom.simple .beian-icon {
    height: 14px;
  }
}

@media (min-width: 769px) {
  .mobile-logo {
    display: none !important;
  }
}

/* 在移动端添加移动端Logo容器 */
.mobile-logo {
  display: none;
}

@media (max-width: 480px) {
  .footer-simple {
    padding: 14px 10px;
  }

  .footer-bottom.simple {
    gap: 10px;
  }

  .footer-bottom.simple .copyright-text {
    font-size: 0.75rem;
  }

  .footer-bottom.simple .beian-link,
  .footer-bottom.simple .icp-link {
    font-size: 0.7rem;
  }

  .footer-bottom.simple .beian-container {
    gap: 4px;
  }

  .back-top-btn {
    bottom: 18px;
    right: 18px;
    width: 36px;
    height: 36px;
  }
}
</style>

<style>
/* 全局下拉面板样式（el-dropdown 渲染到 body） */
.products-dropdown-popper.el-popper {
  border-radius: 18px !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.12), 0 4px 16px rgba(59, 130, 246, 0.08) !important;
  overflow: hidden;
  padding: 0 !important;
}

.products-dropdown-popper .el-dropdown-menu {
  padding: 0 !important;
  border-radius: 18px !important;
}

/* ========== 用户头像下拉菜单 (精致卡片式) ========== */
.user-dropdown-popper.el-popper {
  border: none !important;
  border-radius: 8px !important;
  background: transparent !important;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.14), 0 4px 16px rgba(59, 130, 246, 0.08) !important;
  overflow: hidden;
  padding: 0 !important;
  min-width: 180px !important;
}

.user-dropdown-popper .el-dropdown-menu {
  padding: 0 !important;
  border-radius: 8px !important;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background: #ffffff;
  position: relative;
  overflow: hidden;
}

/* 顶部用户信息卡 */
.user-dropdown-popper .el-dropdown-menu::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  background:
      radial-gradient(ellipse 200px 80px at 30% 0%, rgba(59, 130, 246, 0.12), transparent 70%),
      radial-gradient(ellipse 180px 70px at 80% 20%, rgba(249, 115, 22, 0.10), transparent 70%),
      linear-gradient(180deg, #f8faff 0%, #ffffff 100%);
  z-index: 0;
}

.user-dropdown-popper .el-dropdown-menu__item {
  position: relative;
  z-index: 1;
  padding: 12px 18px !important;
  margin: 0 !important;
  border-radius: 0 !important;
  display: flex !important;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #334155;
  font-weight: 500;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.user-dropdown-popper .el-dropdown-menu__item .el-icon {
  font-size: 16px;
  color: #64748b;
  transition: color 0.25s ease, transform 0.25s ease;
}

.user-dropdown-popper .el-dropdown-menu__item:hover {
  background: rgba(59, 130, 246, 0.06) !important;
  color: #2563eb !important;
}

.user-dropdown-popper .el-dropdown-menu__item:hover .el-icon {
  color: #3b82f6;
  transform: scale(1.1);
}

/* 分隔线 (退出登录上方) - 针对 divided 属性的项 */
.user-dropdown-popper .el-dropdown-menu__item.is-divided,
.user-dropdown-popper .el-dropdown-menu__item.el-dropdown-menu__item--divided,
.user-dropdown-popper .el-dropdown-menu__item:nth-child(2):not(:first-child) {
  border-top: 1px solid rgba(226, 232, 240, 0.8);
  margin-top: 2px !important;
  padding-top: 0 !important;
  border-radius: 0 !important;
}

.user-dropdown-popper .el-dropdown-menu__item.is-divided:hover,
.user-dropdown-popper .el-dropdown-menu__item.el-dropdown-menu__item--divided:hover,
.user-dropdown-popper .el-dropdown-menu__item:nth-child(2):not(:first-child):hover {
  background: rgba(239, 68, 68, 0.06) !important;
  color: #dc2626 !important;
}

.user-dropdown-popper .el-dropdown-menu__item.is-divided:hover .el-icon,
.user-dropdown-popper .el-dropdown-menu__item.el-dropdown-menu__item--divided:hover .el-icon,
.user-dropdown-popper .el-dropdown-menu__item:nth-child(2):not(:first-child):hover .el-icon {
  color: #ef4444;
}
</style>
